import { ErrorCode } from '../../errors';

// PLAN-UC-1, PLAN-UC-6, ADR-017: виды лимитов тарифного плана — общий язык сервера и интерфейса.
// Значения лимитов живут в планах (ведёт администратор); null — без ограничения.

export enum PlanLimit {
  /** Блоги, где пользователь — аккаунт блога (WS-UC-1.CC-1). */
  Blogs = 'blogs',
  /** Люди с ролью владельца или редактора во всех блогах аккаунта, включая его самого (WS-RULE-3). */
  Editors = 'editors',
  /** Сумма размеров оригиналов медиа во всех блогах аккаунта, МБ (MED-UC-1.CC-3). */
  StorageMb = 'storageMb',
  /** Загрузки медиа во все блоги аккаунта за последние 24 часа (MED-UC-1.CC-3). */
  MediaPerDay = 'mediaPerDay',
  /** Созданные посты во всех блогах аккаунта за последние 24 часа (POST-UC-1.CC-4). */
  PostsPerDay = 'postsPerDay',
  /** Трафик медиа одного блога за календарный месяц по UTC, ГБ (MED-RULE-4). */
  TrafficGbPerMonth = 'trafficGbPerMonth',
}

/** Порядок лимитов в формах и таблицах. */
export const PLAN_LIMITS: readonly PlanLimit[] = Object.values(PlanLimit);

/** Значение лимита: целое от 0 до PLAN_LIMIT_MAX или null — без ограничения (PLAN-UC-1.CC-1). */
export type PlanLimitValue = number | null;
export type PlanLimits = Readonly<Record<PlanLimit, PlanLimitValue>>;

export const PLAN_LIMIT_MAX = 1_000_000_000;
export const PLAN_NAME_MAX_LENGTH = 100;
export const PLAN_DESCRIPTION_MAX_LENGTH = 1000;
/** PLAN-UC-1.CC-1: латиница в нижнем регистре, цифры и дефис, 2–32 символа. */
export const PLAN_CODE_PATTERN = /^[a-z0-9][a-z0-9-]{1,31}$/;

/** Окно лимитов «в сутки» — скользящие 24 часа (PLAN-UC-6.CC-2). */
export const PLAN_DAY_MS = 24 * 3600 * 1000;

/** Коды планов, которые знает система: наборы данных, первый администратор (PLAN-RULE-4). */
export enum KnownPlanCode {
  Start = 'start',
  Unlimited = 'unlimited',
}

/** Чем отвечает действие сверх лимита (PLAN-UC-6). */
export const PLAN_LIMIT_ERRORS: Readonly<Record<PlanLimit, ErrorCode>> = {
  [PlanLimit.Blogs]: ErrorCode.PlanLimitBlogs,
  [PlanLimit.Editors]: ErrorCode.PlanLimitEditors,
  [PlanLimit.StorageMb]: ErrorCode.PlanLimitStorage,
  [PlanLimit.MediaPerDay]: ErrorCode.PlanLimitMediaPerDay,
  [PlanLimit.PostsPerDay]: ErrorCode.PlanLimitPostsPerDay,
  [PlanLimit.TrafficGbPerMonth]: ErrorCode.MediaTrafficLimitExceeded,
};

/** Все лимиты без ограничения — основа для разбора частичного набора. */
export const UNLIMITED: PlanLimits = Object.fromEntries(PLAN_LIMITS.map((limit) => [limit, null])) as Record<PlanLimit, PlanLimitValue>;
